/**
 * Shared navigation controls
 *
 * @copyright 2018 Linguistica 360
 */

import { Script, injector } from '../shared/injector.js';

import $ from 'jquery';


injector.injectClass(class extends Script {
    onLoad() {
        this.$navigation = $('#nav .navigation');
        this.$button = $('#nav_button');

        this.$button.on('click', () => {
            if (this.$navigation.hasClass('shown')) this.close();
            else this.open();
        });

        $('.header-menu-button a').on('click', () => {
            if (this.$navigation.hasClass('shown')) this.close();
            else this.open();
            return false;
        });

        $(document).on('click', (e) => {
            const t = e.target;
            if (!this.$navigation.is(t) && !this.$button.is(t)) {
                if (this.$navigation.has(t).length === 0) {
                    if (this.$button.has(t).length === 0) {
                        this.close();
                    }
                }
            }
        });

        $('.menu-heading.toggle').each((_, heading) => {
            const $heading = $(heading);
            $heading.on('click', () => {
                let $items = $heading;
                while (!$items.is('.menu-items')) $items = $items.next();

                $heading.toggleClass('opened');
                $items.toggleClass('opened');
            });
        });

        $('.filter-dropdown').on('change', () => {
            location.href = $('.filter-dropdown').val();
        });
    }

    open() {
        this.$navigation.addClass('shown');
        this.$button.addClass('shown');
    }

    close() {
        this.$navigation.removeClass('shown');
        this.$button.removeClass('shown');
    }
});
